module.exports = __webpack_public_path__ + "static/media/assassinscreed.58f6512b.jpg";